<div class="p-grid">
    <div class="p-md-6 p-col-12">
        <div class="p-text-bold">Client Name</div>
        {{clientRequisitionContactDetail?.clientCompanyName}}
    </div>
    <div class="p-md-6 p-col-12">
        <div class="p-text-bold">Contact Person</div>
        {{clientRequisitionContactDetail?.contactPerson}}
    </div>
</div>
<div class="p-grid">
    <div class="p-md-6 p-col-12">
        <div class="p-text-bold">Contact Email</div>
        {{clientRequisitionContactDetail?.contactEmail}}
    </div>
    <div class="p-md-6 p-col-12">
        <div class="p-text-bold">Contact Phone</div>
        {{clientRequisitionContactDetail?.contactPhone | mask:'(000) 000-0000'}}
    </div>
</div>
<div class="p-grid">
    <div class="p-md-6 p-col-12">
        <div class="p-text-bold">Is Active</div>{{clientRequisitionContactDetail?.isActive}}
    </div>
</div>
